import { createLogger } from '../../Utils/Logger';
/**
 * SoA 序列化器
 * 负责复杂类型的序列化/反序列化和深拷贝
 */
export class SoASerializer {
    /**
     * 序列化值为 JSON 字符串
     */
    static serialize(value, fieldName, options = {}) {
        try {
            if (options.isMap && value instanceof Map) {
                return JSON.stringify(Array.from(value.entries()));
            }
            if (options.isSet && value instanceof Set) {
                return JSON.stringify(Array.from(value));
            }
            if (options.isArray && Array.isArray(value)) {
                return JSON.stringify(value);
            }
            return JSON.stringify(value);
        }
        catch (error) {
            this._logger.warn(`SoA序列化字段 ${fieldName} 失败:`, error);
            return '{}';
        }
    }
    /**
     * 反序列化 JSON 字符串为值
     */
    static deserialize(serialized, fieldName, options = {}) {
        try {
            const parsed = JSON.parse(serialized);
            if (options.isMap) {
                return new Map(parsed);
            }
            if (options.isSet) {
                return new Set(parsed);
            }
            return parsed;
        }
        catch (error) {
            this._logger.warn(`SoA反序列化字段 ${fieldName} 失败:`, error);
            return null;
        }
    }
    /**
     * 深拷贝对象
     */
    static deepClone(obj) {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }
        if (obj instanceof Date) {
            return new Date(obj.getTime());
        }
        if (Array.isArray(obj)) {
            return obj.map((item) => this.deepClone(item));
        }
        if (obj instanceof Map) {
            const cloned = new Map();
            for (const [key, value] of obj.entries()) {
                cloned.set(key, this.deepClone(value));
            }
            return cloned;
        }
        if (obj instanceof Set) {
            const cloned = new Set();
            for (const value of obj.values()) {
                cloned.add(this.deepClone(value));
            }
            return cloned;
        }
        // 普通对象
        const cloned = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                cloned[key] = this.deepClone(obj[key]);
            }
        }
        return cloned;
    }
}
SoASerializer._logger = createLogger('SoASerializer');
//# sourceMappingURL=SoASerializer.js.map